import { render, staticRenderFns } from "./TicketComp.vue?vue&type=template&id=da5550d2&scoped=true&"
import script from "./TicketComp.vue?vue&type=script&lang=js&"
export * from "./TicketComp.vue?vue&type=script&lang=js&"
import style0 from "./TicketComp.vue?vue&type=style&index=0&id=da5550d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5550d2",
  null
  
)

export default component.exports